import { CompactInput, PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import styled from 'styled-components';

const NumberInput = styled(CompactInput)`
    min-width: 50px;
    max-width: 50px;
    text-align: center;
`;

const CoordContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
`;

type Coord = {
    id: string;
    label: React.ReactNode;
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (newValue: number, e: React.ChangeEvent<HTMLInputElement>) => void;
};
export type PropertiesPanelPointPropertyProps = {
    id: string;
    label: React.ReactNode;
    coords: Coord[];
    disabled?: boolean;
};
export const PropertiesPanelPointProperty: React.FC<PropertiesPanelPointPropertyProps> = ({ id, label, disabled, coords }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                {coords.map((coord) => (
                    <CoordContainer>
                        <label htmlFor={`$${id}-${coord.id}-input`}>{coord.label}</label>
                        <NumberInput
                            id={`$${id}-${coord.id}-input`}
                            type={'number'}
                            min={coord.min}
                            max={coord.max}
                            step={coord.step}
                            value={coord.value}
                            disabled={disabled}
                            onChange={(e) => {
                                if (!isNaN(e.target.valueAsNumber)) {
                                    coord.onChange?.(e.target.valueAsNumber, e);
                                }
                            }}
                        />
                    </CoordContainer>
                ))}
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
